import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { CPD_CATEGORY_ENDPOINT } from './endpoints';

const actions = createActions({
  INDUSTRIES: {
    GET_CPD_CATEGORYS: (industryId) => ({ industryId }),
    API: {
      GET_CPD_CATEGORYS: apiResourceActionCreator('cpdCategorys')
    }
  }
})

export const apiAction = (industryId) => commonApiActions.get(CPD_CATEGORY_ENDPOINT(industryId), actions.industries.api.getCpdCategorys)

export function* fetchCpdCategorys(action) {
  yield put(apiAction(action.payload.industryId));
}

const configuration = {
  name: 'getCpdCategorys',
  action: actions,
  sagas: fetchCpdCategorys,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        cpdCategorysIsFetching: true,
        cpdCategorys: []
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        cpdCategorysIsFetching: false,
        cpdCategorys: action.payload.cpdCategorys
      });
    },
    failed: (state, action) => {
      return Object.assign({}, state, {
        industryRolesIsFetching: false,
        error: action.payload.error
      });
    },
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/industry/configurations/cpdCategorys.js